import { AxiosPromise } from 'axios';
import { http } from 'services';

export interface ClearDemoWorkspaceResponse {
  deletedCount: number;
}

export interface SeedDemoWorkspaceResponse {
  success: boolean;
  testId?: string;
  subjectId?: string;
}

export const ClearDemoWorkspace = (orgId: string): AxiosPromise<ClearDemoWorkspaceResponse> =>
  http.request.delete(`/api/organizations/${orgId}/demo-workspace`);

export const SeedDemoWorkspace = (
  orgId: string,
  data?: { useCase?: string; language?: string },
): AxiosPromise<SeedDemoWorkspaceResponse> =>
  http.request.post(`/api/organizations/${orgId}/demo-workspace/seed`, data || {});
